import { action } from "easy-peasy";

const toastsModel = {
  items: [],
  addToast: action((state, payload) => {
    payload.timestamp = Date.now();
    state.items.push(payload);
  }),
  removeToast: action((state, payload) => {
    // couldn't get it to work using filter, but this works. Immuatbility taken care of by immer
    const idx = state.items.findIndex(toast => toast.timestamp === payload);
    state.items.splice(idx, 1);
  })
};
export default toastsModel;
